// extracted by mini-css-extract-plugin
export default {"webplayer":"webplayer_webplayer__8pb8D","cardtop":"webplayer_cardtop__IZEmm","carddown":"webplayer_carddown__HNe+S"};